import React from 'react'
import { useTranslation } from 'react-i18next';
import Images from '../../assets/images';
import './School.css';
import { Box, Button, Grid } from '@mui/material';

const School = () => {
  const { t } = useTranslation();

  return (
    <div className='school' id='school' style={{ scrollMarginTop: 'clamp(96px, 10vw, 212px)' }}>
      <Grid container className='body'>
        <Grid container item xs={12} md={5} className='left' >
          <label className='mobile'>{t(`school.label`)}</label>
          <h1 className='mobile'>{t(`school.title`)}<span>{t(`school.title2`)}</span></h1>
          <img className='image1' src={Images.tiim.school} alt='school' />
          <Box>
            <h2>{t(`school.benefits`)}</h2>
            {
              t(`school.benefitsList`).map((item, index) => (
                <Grid key={index} container flexDirection={'row'} gap={2} noWrap alignItems={'flex-start'}>
                  <img className='check' src={Images.icons.circleCheck2} alt={'check'} />
                  <h4 className='benefit'>{item}</h4>
                </Grid>
              ))
            }
          </Box>
        </Grid>
        <Grid container item xs={12} md={7} className='right' >
          <label className='desktop'>{t(`school.label`)}</label>
          <h1 className='desktop'>{t(`school.title`)}<span>{t(`school.title2`)}</span></h1>
          <img className='image2' src={Images.tiim.school2} alt='school' />
          <h3>{t(`school.subtitle`)}</h3>
          <h4>{t(`school.description`)}</h4>
          <Button className='button' variant="contained" onClick={() => window.location.href = "mailto:hello@tiimschool.com"}>
            {t(`school.button`)}
          </Button>
        </Grid>
      </Grid>
    </div>

  )
}

export default School 